<template>
	<transition 
			appear
			:appear-active-class="$_crsLyt_stylePageLayoutAnimation()">
		<v-row class="row_" no-gutters>
			<v-col>
				<v-carousel
						:class="$_crsLyt_styleCarouselFlat ? 'flat_' : ''"
						:height="$_crsLyt_stateAppIsMobileScreen ? 'calc(100vh - 56px)' : 'calc(100vh - 64px)'"

						:cycle="isVideo_ ? false : $_crsLyt_styleCarouselCycle"
						:dark="$_crsLyt_styleCarouselDark"
						:delimiter-icon="$_crsLyt_styleCarouselDelimiterIcon"
						:hide-delimiter-background="$_crsLyt_styleCarouselHideDelimiterBackground"
						:hide-delimiters="isVideo_ ? true : $_crsLyt_styleCarouselHideDelimiters"
						:interval="$_crsLyt_styleCarouselInterval"
						:light="$_crsLyt_styleCarouselLight"
						:next-icon="$_crsLyt_styleCarouselNextIcon"
						:prev-icon="$_crsLyt_styleCarouselPrevIcon"
						:progress="$_crsLyt_styleCarouselProgress"
						:progress-color="$_crsLyt_styleCarouselProgressColor"
						:show-arrows="$_crsLyt_styleCarouselShowArrows"
						:show-arrows-on-hover="$_crsLyt_styleCarouselShowArrowsOnHover"
						:touchless="isVideo_ ? true : false">
					<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
						<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
							<v-carousel-item :key="contentKey">
								<v-card tile>
									<template v-if="isObject(contentVals.image)">
										<v-img	cover
												:height="$_crsLyt_stateAppIsMobileScreen ? 'calc(100vh - 56px)' : 'calc(100vh - 64px)'"
												position="center"

												:src="$_crsLyt_styleContentImageUrl(contentVals)"

												@click="openLink(contentVals.link)" />
									</template>
									<template v-if="isObject(contentVals.video)">
										<carousel-video
												:contentKey="contentKey"
												:contents="contents"
												:inits="inits"
												@play="isVideo_ = true"
												@paused="isVideo_ = false"
												@ended="isVideo_ = false" />
									</template>
								</v-card>
							</v-carousel-item>
						</template>
					</template>
				</v-carousel>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'CarouselLayout',
		props: {
			inits: Object,
			contents: Object
		},
		data() {
			return {
				isVideo_: false
			}
		},
		computed: {
			// state
			$_crsLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// style
			$_crsLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_crsLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_crsLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_crsLyt_styleCarousel() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'carousel')
			},
			$_crsLyt_styleCarouselCycle() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.cycle)
			},
			$_crsLyt_styleCarouselDark() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.dark)
			},
			$_crsLyt_styleCarouselDelimiterIcon() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.delimiterIcon)
			},
			$_crsLyt_styleCarouselFlat() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.flat)
			},
			$_crsLyt_styleCarouselHideDelimiters() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.hideDelimiters)
			},
			$_crsLyt_styleCarouselHideDelimiterBackground() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.hideDelimiterBackground)
			},
			$_crsLyt_styleCarouselInterval() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.interval)
			},
			$_crsLyt_styleCarouselLight() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.light)
			},
			$_crsLyt_styleCarouselNextIcon() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.nextIcon)
			},
			$_crsLyt_styleCarouselPrevIcon() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.prevIcon)
			},
			$_crsLyt_styleCarouselProgress() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.progress)
			},
			$_crsLyt_styleCarouselProgressColor() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.progressColor)
			},
			$_crsLyt_styleCarouselShowArrows() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.showArrows)
			},
			$_crsLyt_styleCarouselShowArrowsOnHover() {
				const self_ = this;
				const carousel_ = self_.$_crsLyt_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.showArrowsOnHover)
			},
			// (content)
			$_crsLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_crsLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_crsLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		}
	}
</script>

<style scoped>
	.row_ {
		margin-bottom: -24px;
	}
	.flat_.v-carousel {
		box-shadow: none;
	}
</style>
